import React, { useEffect, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';

export const AuthCallback = () => {
  const { handleGoogleCallback, setUser } = useAuth();
  const navigate = useNavigate();
  const hasProcessed = useRef(false);

  useEffect(() => {
    // CRITICAL: Use useRef to prevent double-processing in StrictMode
    if (hasProcessed.current) return;
    hasProcessed.current = true;

    const processCallback = async () => {
      try {
        // Extract session_id from URL hash
        const hash = window.location.hash;
        const params = new URLSearchParams(hash.substring(1));
        const sessionId = params.get('session_id');

        if (sessionId) {
          const userData = await handleGoogleCallback(sessionId);
          // Navigate to dashboard with user data to skip auth check
          navigate('/', { state: { user: userData }, replace: true });
        } else {
          navigate('/login', { replace: true });
        }
      } catch (error) {
        console.error('Auth callback error:', error);
        navigate('/login', { replace: true });
      }
    };

    processCallback();
  }, [handleGoogleCallback, navigate, setUser]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-[#F9FAFB]" data-testid="auth-callback">
      <div className="text-center">
        <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-[#33AADD] mx-auto"></div>
        <p className="mt-4 text-[#6B7280]">Completing sign in...</p>
      </div>
    </div>
  );
};

export default AuthCallback;
